var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropzoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.564 9.797a.88.88 0 000 1.226l3.92 3.92a.865.865 0 00.95.194.808.808 0 00.276-.194l3.95-3.95a.85.85 0 000-1.225.88.88 0 00-1.226 0l-2.45 2.465V1.12a.865.865 0 10-1.73 0v11.142L7.79 9.797a.88.88 0 00-1.225 0z",
    fill: "#0DD1C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27 9.315a.937.937 0 00-.936.937v7.928A3.82 3.82 0 004.154 22h13.694a3.82 3.82 0 003.82-3.82v-7.928a.937.937 0 10-1.875 0v7.928a1.946 1.946 0 01-1.945 1.946H4.153a1.946 1.946 0 01-1.946-1.946v-7.928a.937.937 0 00-.937-.937z",
    fill: "#0DD1C5"
  })));
}
export default SvgDropzoneIcon;